export const limitString = (string, limit) => {
  return string.length > limit ? string.slice(0, limit) + '...' : string;
};
